import { FreeTagDetailDto } from "apis/data-contracts";
import { atom } from "recoil";

export const documentFreeTagsState = atom<FreeTagDetailDto[]>({
  key: "documentFreeTagsState",
  default: [],
});

export const isFormReselectedState = atom<boolean>({
  key: "isFormReselectedState",
  default: false,
});

export const showApproverSignState = atom<boolean>({
  key: "showApproverSignState",
  default: false,
});
